export const cart: object = {
  cartDetails: {
    id: 'ID',
    proceedToCheckout: 'Proceed to Checkout',
    cartName: 'Cart #{{code}}',
    remove: 'Remove',
    edit: 'Edit',
  },
  cartItems: {
    id: 'ID',
    description: 'Description',
    item: 'Item',
    itemPrice: 'Item price',
    quantity: 'Qty',
    quantityTitle: 'The quantity represents the total number of this item in your cart.',
    itemsThatNeedToBeCheckedOutSeparately: 'You might have items that need to be checked out separately. Please check out the solution(s) below first. You can visit',
    toStartWithTheOtherItems: 'to start with the other items.',
    total: 'Total',
    cartTotal: 'Cart total ({{count}} item)',
    cartTotal_plural: 'Cart total ({{count}} items)',
    removeProductSuccess: 'has been removed from your cart',
    additionalLicenses: 'Additional Licenses',
    priceSubtitle: 'Subtotal',
    deployment: 'Deployment',
    duration: 'Duration',
    priceTooltip: {
      header: 'Pricing Summary',
      per: {
        header: 'Price per License',
        licenseMaterial: 'License Material',
        quantity: 'Quantity',
        pricePer: 'Price per License/ Month',
      },
      breakdown: {
        header: 'Order Summary',
        configuration: 'Configuration',
        duration: 'Duration',
        cost: 'Cost',
      },
      subtotal: {
        title: 'Subtotal',
        excludingTax: 'Excluding tax',
        existingPricing: 'Existing contract pricing, billing and terms apply',
        taxCalculated: 'Tax Calculated at Checkout',
      }
    },
    initialPurchase: 'Initial purchase',
    discounts: {
      discount: '- {{formattedAbsoluteValue}} discount',
      youSaved: 'You saved {{formattedAbsoluteValue}}'
    }
  },
  orderCost: {
    orderSummary: 'Order Summary',
    subtotal: 'Subtotal after discounts:',
    estimatedShipping: 'Estimated shipping:',
    discount: 'You saved:',
    salesTax: 'Sales Tax:',
    grossTax: 'The order total does not include tax of',
    total: 'Total:',
    recurringTotal: 'Recurring Annual Total'
  },
  voucher: {
    coupon: 'Promotion code',
    coupon_plural: 'Coupon codes',
    apply: 'Apply',
    placeholder: 'Enter code',
    applyVoucherSuccess: '{{voucherCode}} has been applied.',
    removeVoucherSuccess: '{{voucherCode}} has been removed.',
    anchorLabel: 'Enter or remove your coupon code',
    vouchersApplied: 'Applied coupons',
    errors: {
      invalidCouponCode: 'Your entered code is not valid.',
      alreadyExistingCoupon: 'Your entered code is already applied.',
      cartFailedRequirements: 'Your cart doesn\'t meet the promotion conditions.',
      amountExceeded: 'Entry is temporarily blocked due to maximum attempts exceeded, please try again later.',
      voucherNoLongerValid: 'Your applied code "{{voucherCode}}" is no longer valid.',
      promoNoLongerValid: 'Your applied promotion is no longer valid.'
    }
  },
  cart: {
    ariaLabel: 'Cart',
    checkOut: 'Check Out',
    paymentInfo: 'PO-Numbers, payment and contacts can be managed during Checkout',
    account: 'Account',
    buyerDetails: 'Buyer Details',
    personalDetails: 'Personal details',
    technicalContact: 'Technical Contact',
    companyDetails: 'Company Details',
    primaryAccessLocation: 'Primary Access Location',
    billing: 'Billing',
    paymentMethod: 'Payment Method',
    billTo: 'Bill To',
    taxExemptionDoc: 'Tax Exemption Document',
    billingAddress: 'Billing Address',
    creditCard: 'Credit Card',
  },
};
